import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import './FourthSection.scss';
import RoyaltyManagementIcon from '../../../assets/Images/Royalty Management.svg';
import LaptopImage from '../../../assets/Images/laptop home screen 2.png';
import UnifiedButton from '../../shared/Button';
import { Slide } from 'react-awesome-reveal';
import { useNavigate } from 'react-router-dom';

function FourthSection() {
    const navigate = useNavigate();

    const handleJoinClick = () => {
        navigate('/pricing');
        window.scrollTo(0, 0);
    };

    return (
        <Box className="fourth-section">
            <Box className="image-container">
                <img src={LaptopImage} alt="Royalty Management Laptop" className="laptop-image" />
            </Box>

            <Box className="content">
                <Slide direction="up" triggerOnce={true} duration={1000}>
                    <Box className="heading">
                        <img src={RoyaltyManagementIcon} alt="Royalty Management Icon" className="icon" />
                        <Typography variant="h4" component="h2" className="section-title">
                            Royalty Management
                        </Typography>
                    </Box>
                    <Typography variant="h6" component="h3" className="subtitle">
                        Earn from Your Music, However You Choose
                    </Typography>
                    <Typography variant="body1" component="p" className="description">
                        With our user-friendly platform, tracking and managing your royalty payouts is simple.
                        Whether it's in USD, EUR, GBP, or any of the 93 supported currencies, we've got you covered.
                    </Typography>
                </Slide>
                <Box>
                    <UnifiedButton className="cta-button" onClick={handleJoinClick} textContent={'Join at No Cost'} />
                </Box>
            </Box>


        </Box >
    );
}

export default FourthSection;
